import * as React from "react";
import { useEffect, useState } from "react";
import { styled } from "@mui/material";
import { PatientColorMap } from "../../../../layout/patientColorMap";
import {
  NumericInputControllerProps,
  useNumericInputController,
} from "./useNumericInputController";
import { MeasurementUnits, QualifierFragment } from "fe-common/graphql";
import { NumericInputView } from "./ui(Views)/numericInputView";
import { UnitChangerView } from "./ui(Views)/unitChangerView";
import { useUnitConverter } from "./logic(controllerHooks)/useUnitConveter";
import { UnitEndAdornment } from "./ui(Views)/unitEndAdornment";
import { onRtl } from "fe-web-components/rtl/rtlStyles";

//region [[ Styles ]]
const NumericInputContainer = styled("div")({
  display: "flex",
  flexFlow: "column",
  width: "100%",
  direction: "ltr",
});

export const ErrorText = styled("div")({
  fontSize: "11px",
  color: PatientColorMap.Red,
  width: "100%",
  margin: "5px 0",
  ...onRtl({
    direction: "rtl",
  }),
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface UnitConverter {
  unit: MeasurementUnits;
  displayText?: string;
  converters: [
    {
      from: MeasurementUnits;
      converter: (number) => number;
    },
  ];
}

export interface NumericInputProps extends NumericInputControllerProps {
  className?: string;
  unitConverts?: UnitConverter[];
  onEnter?: () => void;
  rangeItems?: QualifierFragment[];
  placeholder?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]

//endregion [[ Functions ]]
export const NumericInput = ({
  onEnter,
  unitConverts,
  rangeItems,
  suggestion,
  onValidValue,
  index,
  ...props
}: NumericInputProps) => {
  const [placeholder, setPlaceholder] = useState("");

  const { currentUnitConverter, handleUnitChange } = useUnitConverter({
    rangeItems,
    unitConverters: unitConverts,
  });

  const {
    stringValue,
    errorText,
    normalAverage,
    handleValueChanged,
  } = useNumericInputController({
    suggestion,
    onValidValue,
    currentUnitConverter,
    index,
  });

  // Make placeholder get the average everytime the average changes or the units chage
  useEffect(
    () =>
      setPlaceholder(
        currentUnitConverter?.convertFromRange?.(normalAverage).toFixed(0),
      ),
    [normalAverage, currentUnitConverter],
  );

  const endAdornment = unitConverts ? (
    <UnitChangerView
      unitConverts={unitConverts}
      currentUnitConverter={currentUnitConverter}
      onUnitConverterSelected={handleUnitChange}
    />
  ) : (
    <UnitEndAdornment range={rangeItems} />
  );

  return (
    <NumericInputContainer className={props.className}>
      <NumericInputView
        className={"numeric-input-view"}
        value={stringValue}
        onChange={handleValueChanged}
        placeholder={props.placeholder || placeholder}
        endAdornment={endAdornment}
        errorText={errorText}
        onEnter={onEnter}
      />
    </NumericInputContainer>
  );
};
